import React, {useState, useEffect} from "react";
import {Link, useParams} from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const viewImg = require("./../assets/img/viewImg.png");
const backBtn = require("./../assets/img/back-btn.svg").default;

const ViewOneHistory = () => {
  const [userData, setUserData] = useState(null);
  const [fileDetails, setFileDetails] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [images, setImages] = useState();
  const [status, setStatus] = useState();
  const [signImage, setSignImage] = useState();

  const {fileId} = useParams(); // Get the file name from route params

  useEffect(() => {
    // Retrieve user data from local storage
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);
    // Fetch file details using the specific file's name
    fetch(`https://cliqestimatebuilder.com/waiver_admin/histories/${fileId}`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
    })
      .then(response => response.json())
      .then(data => {
        setFileDetails(data.data);
      })
      .catch(error => {
        console.error("Error fetching file details:", error);
      });
  }, [fileId]);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewOne">
            <div className="viewOneLeft">
              <Link to="/histoty">
                <img src={backBtn} alt="image" />
              </Link>
              <h3>View History</h3>
            </div>
          </div>
          <div className="viewBox">
            <ul className="previewOne">
              {fileDetails ? (
                <>
                  <li>
                    <label>Purpose:</label>
                    <div className="dscFile">{fileDetails.purpose}</div>
                  </li>
                  <li>
                    <label>Created at:</label>
                    <div className="dscFile">{fileDetails.created_at}</div>
                  </li>
                </>
              ) : null}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewOneHistory;
